module.exports = __webpack_public_path__ + "assets/entrance-rain-955d8829.png";